import "./RemoveButton.scss";
import ImgBasket from "../../images/basket_sprite.svg";
import { FC } from "react";
import ImageSprite from "../ImageSprite/ImageSprite";

interface RemoveButtonProps {
    onClick: () => void;
    img?: "top" | "center";
    position?: "top_center" | "right";
}

const RemoveButton: FC<RemoveButtonProps> = ({ onClick, ...props }) => {
    return (
        <button
            type="button"
            className="remove_button"
            {...props}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
        >
            <ImageSprite iconSprite={`${ImgBasket}#remove`} />
        </button>
    );
};

export default RemoveButton;
